import Plus from '../src/icon/plus';
export default Plus;